import { render, staticRenderFns } from "./dictionarymodal.vue?vue&type=template&id=0b33ff60&scoped=true&"
import script from "./dictionarymodal.vue?vue&type=script&lang=js&"
export * from "./dictionarymodal.vue?vue&type=script&lang=js&"
import style0 from "./dictionarymodal.vue?vue&type=style&index=0&id=0b33ff60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b33ff60",
  null
  
)

export default component.exports